var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.103,
    height: 12.104,
    viewBox: "0 0 12.103 12.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_akar-edit",
    "data-name": "Icon akar-edit",
    transform: "translate(-5.5 -3.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9663",
    "data-name": "Path 9663",
    d: "M20.042,6.058l1.371,1.37m-.489-2.577L17.218,8.557a1.371,1.371,0,0,0-.375.7L16.5,10.971l1.713-.343a1.369,1.369,0,0,0,.7-.375l3.706-3.706a1.2,1.2,0,0,0-1.7-1.7Z",
    transform: "translate(-5.97)",
    fill: "none",
    stroke: "#01a27c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9664",
    "data-name": "Path 9664",
    d: "M15.706,13.971v1.941a1.294,1.294,0,0,1-1.294,1.294H7.294A1.294,1.294,0,0,1,6,15.912V8.794A1.294,1.294,0,0,1,7.294,7.5H9.235",
    transform: "translate(0 -1.706)",
    fill: "none",
    stroke: "#01a27c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGreen);
export default __webpack_public_path__ + "static/media/edit-icon-green.bed5c1506bff1a96fb0f051fef2249d5.svg";
export { ForwardRef as ReactComponent };